// extracted by mini-css-extract-plugin
export default {"subscription":"subscription-form_subscription__BwK2k","emailInput":"subscription-form_emailInput__XevTI"};